import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import { useEffect, useState } from 'react';
import CouponService from '../../../../service/coupon/Coupon';
import { formatDateToDotShort } from '../../../../func/func';

interface ListItem {
  create_time: string;
  name: string;
  expire_time: string;
}

interface Props {
  onClose: () => void;
}

function WinningListModal({ onClose }: Props) {
  const [list, setList] = useState<ListItem[]>([]);

  const getList = async () => {
    try {
      const res = await CouponService.randomList();
      setList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <BottomModal onClose={onClose}>
      <Header>
        <CloseButton onClick={onClose}>
          <img src="/assets/images/close/close-black24.svg" alt="" />
        </CloseButton>
      </Header>
      <Inner>
        <Title>당첨 내역</Title>
        <Table>
          <colgroup>
            <col width={92} />
            <col />
            <col width={92} />
          </colgroup>
          <thead>
            <tr>
              <Th>당첨일자</Th>
              <Th>당첨 내역</Th>
              <Th>유효기간</Th>
            </tr>
          </thead>
          <tbody>
            {list.length > 0 ? (
              list.map((item, idx) => (
                <tr key={`${item.create_time}-${item.name}-${idx}`}>
                  <Td>{formatDateToDotShort(item.create_time)}</Td>
                  <Td>{item.name}</Td>
                  <Td>~{formatDateToDotShort(item.expire_time)}</Td>
                </tr>
              ))
            ) : (
              <tr>
                <Td colSpan={3}>당첨 내역이 없습니다.</Td>
              </tr>
            )}

            {/* <tr>
              <Td>asdfsd</Td>
              <Td>asdfsd</Td>
              <Td>asdfsd</Td>
            </tr> */}
          </tbody>
        </Table>
      </Inner>
      <Bottom>
        <ConfirmButton onClick={onClose}>확인</ConfirmButton>
      </Bottom>
    </BottomModal>
  );
}

export default WinningListModal;

const Header = styled.div`
  display: flex;
  width: 360px;
  padding: 24px 20px 0 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const CloseButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #f2f2f2;

  & > img {
    width: 20px;
    height: 20px;
  }
`;

const Inner = styled.div`
  display: flex;
  padding: 0 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  max-height: 488px;
  overflow-y: auto;
`;

const Title = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-family: Paperlogy;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 33.6px */
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`;

const Th = styled.th`
  width: 100%;
  padding: 10px 12px;
  background: #f7f8fc;
  color: #616161;
  font-size: 15px;
  font-weight: 500;
  line-height: 150%; /* 22.5px */
  letter-spacing: -0.3px;
  border-bottom: 1px solid #e1e2e4;
  border-top: 1px solid #e1e2e4;
  white-space: nowrap;

  &:not(:first-child) {
    border-left: 1px solid #e1e2e4;
  }
`;

const Td = styled.td`
  width: 100%;
  padding: 8px 9px;
  color: #222;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid #e1e2e4;
  text-align: center;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:not(:first-child) {
    border-left: 1px solid #e1e2e4;
  }
`;

const Bottom = styled.div`
  display: flex;
  padding: 24px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const ConfirmButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  background: #222;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.64px;
`;
